<template>
  <el-menu
    active-text-color="#409eff"
    :default-openeds="openedMenus"
    :default-active="$route.name"
    :router="true"
    @open="open"
    @close="close"
  >
    <!-- unique-opened -->
    <submenu :items="items" />
  </el-menu>
</template>
<script>
import Submenu from "./submenu.vue";
import Store from "store";

export default {
  name: "Menu",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    openeds: {
      type: Array,
      default: () => [],
    },
    active: String,
  },
  data() {
    return {
      openedMenus: [],
    };
  },
  mounted() {
    // 从本地缓存中获得 菜单栏 是打开是关闭
    this.openedMenus = Store.get("openedMenus") || this.openeds;
  },
  methods: {
    open(name, indexPath) {
      Store.set("openedMenus", this.openedMenus);
    },
    close(name) {
      Store.set("openedMenus", this.openedMenus);
    },
  },
  components: {
    Submenu,
  },
};
</script>